/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateInboxDtoGen,
  MrfiktivExceptionViewmodelGen,
  MrfiktivInboxControllerGetParamsGen,
  MrfiktivInboxViewModelGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateInboxDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Inbox<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Inbox
   * @name InboxControllerCreate
   * @summary (INBOX - POST) Creates an inbox for a given partner
   * @request POST:/partner/{partnerId}/inbox
   * @secure
   * @response `201` `MrfiktivInboxViewModelGen` Inbox created
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  inboxControllerCreate = (partnerId: string, data: MrfiktivCreateInboxDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivInboxViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/inbox`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Inbox
   * @name InboxControllerGet
   * @summary (INBOX - READ) Gets all inboxes for a given partner
   * @request GET:/partner/{partnerId}/inbox
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivInboxViewModelGen)[] })`
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  inboxControllerGet = ({ partnerId, ...query }: MrfiktivInboxControllerGetParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivInboxViewModelGen[] }, MrfiktivExceptionViewmodelGen>(
      {
        path: `/partner/${partnerId}/inbox`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params
      }
    );
  /**
   * No description
   *
   * @tags Inbox
   * @name InboxControllerUpdate
   * @summary (INBOX - UPDATE) Updates an inbox for a given partner
   * @request PUT:/partner/{partnerId}/inbox/{inboxId}
   * @secure
   * @response `200` `MrfiktivInboxViewModelGen` Updated inbox document
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  inboxControllerUpdate = (
    partnerId: string,
    inboxId: string,
    data: MrfiktivUpdateInboxDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInboxViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/inbox/${inboxId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Inbox
   * @name InboxControllerGetOne
   * @summary (INBOX - READ) Gets a particular inbox for a given partner
   * @request GET:/partner/{partnerId}/inbox/{inboxId}
   * @secure
   * @response `200` `MrfiktivInboxViewModelGen` Inbox returned
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  inboxControllerGetOne = (partnerId: string, inboxId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivInboxViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/inbox/${inboxId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Inbox
   * @name InboxControllerRemove
   * @summary (INBOX - DELETE) Deletes an inbox for a given partner
   * @request DELETE:/partner/{partnerId}/inbox/{inboxId}
   * @secure
   * @response `200` `MrfiktivInboxViewModelGen` Inbox deleted
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  inboxControllerRemove = (partnerId: string, inboxId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivInboxViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/inbox/${inboxId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Inbox
   * @name InboxControllerMigrate
   * @summary (ADMIN) Migrate inboxes from partner settings to inbox collection
   * @request POST:/inbox/migrate
   * @secure
   * @response `200` `void` Migration result
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` Not Found
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  inboxControllerMigrate = (params: RequestParams = {}) =>
    this.http.request<void, MrfiktivExceptionViewmodelGen>({
      path: `/inbox/migrate`,
      method: "POST",
      secure: true,
      ...params
    });
}
